import { InputProps as AntdInputProps } from 'antd';

export type InputProps = AntdInputProps & {}

export type DefaultInputProps = {};

export const defaultProps: DefaultInputProps = {};
